exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-2ee315d4] .ant-upload-picture-card-wrapper {\n  width: auto;\n}\n", ""]);

// exports
